/**
 * Phép tính thuần của nhóm màn vận hành (Tổng quan, Nhật ký truy vết, Thử nghiệm) — port các hàm nhỏ rải trong
 * `DashboardView`, `SuDung`, `DemLuot`, `LichSuTroChuyen` của native. Không dựng chuỗi hiển thị: trả số và mã để view
 * tự dịch.
 */

/** Tỉ lệ làm tròn tới phần trăm; mẫu số 0 thì `null` (view hiện gạch dài, không hiện "0%"). */
export function phanTram(a: number, b: number): number | null {
  return b ? Math.round((a / b) * 100) : null;
}

/**
 * Thời gian cho NGƯỜI đọc: dưới một giây thì mili giây ("0,012 giây" bắt người đọc đếm số 0), từ một giây trở lên thì
 * giây, một chữ số thập phân ("1 480 ms" phải quy đổi trong đầu mới biết lâu hay nhanh).
 */
export function thoiGianDoc(ms: number | null): { donVi: 'ms' | 'giay'; so: number } | null {
  if (ms === null) return null;
  if (ms < 1000) return { donVi: 'ms', so: ms };
  return { donVi: 'giay', so: Math.round(ms / 100) / 10 };
}

/** "2026-09-03" → "03/09". Cắt chuỗi tay: `new Date` sẽ kéo theo múi giờ. */
export function ngayNgan(iso: string): string {
  const [, thang, ngay] = iso.split('-');
  return `${ngay}/${thang}`;
}

/** Thứ trong tuần (0 = Chủ nhật) của một ngày ISO, tính ở UTC để không lệch múi giờ; `null` khi chuỗi hỏng. */
export function thuCuaNgay(iso: string): number | null {
  const [y, m, d] = iso.split('-').map(Number);
  if (!y || !m || !d) return null;
  return new Date(Date.UTC(y, m - 1, d)).getUTCDay();
}

/** Nhãn giờ thưa ra mỗi 3 giờ — 24 nhãn chen nhau trên một hàng thì không đọc được cái nào. */
export const BUOC_NHAN_GIO = 3;

export function coNhanGio(gio: number): boolean {
  return gio % BUOC_NHAN_GIO === 0;
}

/**
 * Chiều cao cột (phần trăm) so với cột CAO NHẤT. Cột có giá trị không bao giờ thấp hơn 4% (vẫn thấy được); cột 0 trả
 * `0` để view vẽ vạch rỗng — ngày không có lượt hỏi phải còn chỗ đứng, không thì biểu đồ đọc thành "vẫn đều".
 */
export function chieuCaoCot(n: number, dinh: number): number {
  if (!n) return 0;
  return Math.max(4, Math.round((n / Math.max(1, dinh)) * 100));
}

/**
 * Bề rộng thanh tỉ lệ so với dòng CAO NHẤT trong khối, không với tổng: khi một nguồn chiếm 90% thì mọi thanh còn lại
 * dí sát mép trái và khối mất khả năng so sánh những dòng nhỏ với nhau.
 */
export function beRongThanh(n: number, dinh: number): number {
  return Math.max(2, Math.round((n / Math.max(1, dinh)) * 100));
}

/** Máy chủ nói bằng giây; người vận hành nghĩ bằng phút. Quy đổi một chỗ, làm tròn một chữ số thập phân. */
export function giayRaPhut(giay: number): number {
  return Math.round((giay / 60) * 10) / 10;
}

export function phutRaGiay(phut: number): number {
  return Math.round(phut * 60);
}

/** Vai của khách trên khung nhúng mang dạng `nhung:<mã phiên>` — hiện "Khách (khung nhúng)", không hiện mã phiên. */
export const TIEN_TO_KHACH = 'nhung:';

export function laKhachNhung(vai: string): boolean {
  return vai.startsWith(TIEN_TO_KHACH);
}

/**
 * Câu lệnh có bị bộ canh cổng VIẾT LẠI không — in lại câu người ta gõ là in một câu KHÁC với câu đã sinh ra những con
 * số bên dưới.
 */
export function daVietLai(guiLen: string, daChay: string | null | undefined): boolean {
  return daChay !== null && daChay !== undefined && daChay.trim() !== guiLen.trim();
}

/** Đọc trường chuỗi trong `payload` tự do của một tin nhắn đã lưu (có thể vắng hoặc sai kiểu). */
export function chuoiTrongPayload(payload: Record<string, unknown> | null | undefined, khoa: string): string | null {
  const v = payload?.[khoa];
  return typeof v === 'string' && v ? v : null;
}
